import React from 'react';
import cn from 'classnames';

import LabelStyles from '../../../shared/label-style';
import {focusOnNextInput} from '../../../utils/inputs';

import styles from './styles.module.scss';

export type ZUICheckbox = (props: {
  id: string;
  checked: boolean;
  label?: string;
  /* Overrides the accessible name when the visible label repeats across
     sibling checkboxes and only their surrounding context tells them apart. */
  ariaLabel?: string;
  testId?: string;
  reverse?: boolean;
  disabled?: boolean;
  className?: string;
  checkHandler: () => void;
}) => React.ReactElement;

const Checkbox: ZUICheckbox = ({
  id,
  disabled,
  checked,
  testId,
  label,
  ariaLabel,
  reverse,
  className,
  checkHandler,
}) => {
  const legacyReverse = className?.includes('reverse');

  const wrapperKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ): void => {
    if (event.key === 'Tab') {
      event.preventDefault();

      // Logic to tab between inputs
      focusOnNextInput(event.currentTarget);

      return;
    }

    if (event.nativeEvent.code === 'Enter') {
      checkHandler?.();
    }
  };

  return (
    <div className={cn(styles.checkbox__wrapper, className)}>
      {label?.length ? (
        <LabelStyles htmlFor={id}>{label}</LabelStyles>
      ) : (
        <LabelStyles htmlFor={id} className="visually-hidden">
          Checkbox
        </LabelStyles>
      )}

      <div
        className={cn(styles.checkbox__container, {
          [styles.checkbox__container__modReverse]: reverse || legacyReverse,
        })}>
        <input
          id={id}
          data-testid={testId}
          aria-label={
            ariaLabel ?? (typeof label === 'string' ? label : undefined)
          }
          type="checkbox"
          checked={checked}
          onChange={!disabled ? checkHandler : undefined}
          onKeyDown={wrapperKeyDown}
          disabled={disabled}
        />
        <i className="fa-solid fa-check" title="checkbox check mark icon" />
      </div>
    </div>
  );
};

export default Checkbox;
